import { TMessage } from "graphql/messages";

export const selectMessageTimestamp = (
  message?: Pick<TMessage, "lastStatusTimestamp" | "externalTimestamp" | "insertedAt">
): string => message?.lastStatusTimestamp ?? message?.externalTimestamp ?? message?.insertedAt;
